import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import * as messenger from '../lib/messenger';
import ShareSDKHeader from './ShareSDKHeader';
import SignInForm from 'auth/components/SignInForm';

import View from 'components/View';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Text from 'components/Text';
import Row from 'components/Row';

import { COMPOSER_PATH } from '../routes';

import './styles/ShareSDKLoginPopup.scss';

const SEND_SIGN_IN_TO_OPENER = () => messenger.send('SIGN_IN', window.opener);
const LOG_IN_TO_COMPOSER = () => window.location.replace(COMPOSER_PATH + window.location.search);

type Props = {
  notIframe?: boolean;
};

messenger.removeIsTrusted();

class ShareSDKLoginPopup extends React.Component<Props> {
  componentDidMount() {
    if (this.props.notIframe) {
      CurrentUser.addSignInListener(LOG_IN_TO_COMPOSER);
    } else {
      CurrentUser.addSignInListener(SEND_SIGN_IN_TO_OPENER);
      this.listener = messenger.listen('SIGN_IN_ACK', window.close);
    }
  }

  componentWillUnmount() {
    if (this.props.notIframe) {
      CurrentUser.removeSignInListener(LOG_IN_TO_COMPOSER);
    } else {
      CurrentUser.removeSignInListener(SEND_SIGN_IN_TO_OPENER);
    }

    if (this.listener) {
      this.listener.unlisten();
    }
  }

  listener: any;

  render() {
    return (
      <div className="ShareSDKLoginPopup">
        <ShareSDKHeader />
        <View center className="ShareSDKLoginPopup-View">
          <Row size="small">
            {/* @ts-expect-error */}
            <Text title="Log In" align="center" size="xxxxlarge">
              Log In
            </Text>
          </Row>
          <Box size="small">
            <BoxBody>
              <SignInForm />
            </BoxBody>
          </Box>
        </View>
      </div>
    );
  }
}

export default ShareSDKLoginPopup;
